import "../styles/story.css";
// import storyImage from '../../images/mapMarker.webp'

export default function Eighteen() {
  return (
    <div className="containerStory">
      <div className="storyHeading">
        <h2>2018</h2>
        {/* <img src={storyImage} alt="Store location marker"/> */}
      </div>
      <p>
      Our journey began in 2018 with our Ibrox store. We introduced Glasgow to a variety of slush flavours.
        <br />
        <span>Starting with 30 tasty flavours.</span>
      </p>
    </div>
  );
}
